import React, { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { CheckIcon } from '@heroicons/react/outline';
import { useSelector, useDispatch } from 'react-redux';

import $ from 'jquery';

import WarehouseCreate from './Create';
import { SubmitButton, DeleteButton } from '../../components/Base';
import { API_URL, DATATABLES_DEFAULT_CONFIG } from '../../constants/env';
import { deleteWarehouse } from '../../actions/warehouse';

export default function Warehouse() {
  const warehouseFormRef = useRef();

  const { result: authenticatedUser } = useSelector((state) => state.authenticatedUser);
  const { refresh } = useSelector((state) => state.warehouse);
  const dispatch = useDispatch();

  useEffect(() => {
    initializeDataTables();
  }, [refresh]);

  const initializeDataTables = () => {
    $('#warehouseDataTable').DataTable().destroy();
    $('#warehouseDataTable').DataTable({
      ...DATATABLES_DEFAULT_CONFIG,
      ajax: {
        url: `${API_URL}/warehouse?source=datatables`,
        dataSrc: 'data',
        beforeSend: (xhr) =>
          xhr.setRequestHeader('Authorization', `Bearer ${authenticatedUser.token}`),
      },
      columns: [
        { data: 'name' },
        {
          data: 'pic',
          render: (data, type, row) => `${data}<br />
            (Ph: ${row.pic_phone})`,
        },
        {
          data: 'street_address',
          render: (data, type, row) => `${data}<br />
            ${row.district}, ${row.city}, ${row.province} ${row.zip_code}`,
        },
        {
          data: 'ipay88_merchant_code',
          render: (data, type, row) => `${data} / ${row.ipay88_merchant_key}`,
        },
        {
          data: 'is_default',
          createdCell: (cell, cellData, rowData) =>
            ReactDOM.render(
              Number(cellData) === 1 && <CheckIcon className="w-6 h-6 text-green-600" />,
              cell,
            ),
        },
        {
          data: 'id',
          searchable: false,
          sortable: false,
          createdCell: (cell, cellData, rowData) =>
            ReactDOM.render(
              <div>
                <SubmitButton
                  color="blue"
                  textClass="text-white text-xs"
                  paddingClass="px-3 py-2 mr-1"
                  text="Edit"
                  onClick={() => onPressEdit(rowData)}
                />
                {Number(rowData.is_default) !== 1 && (
                  <DeleteButton
                    color="red"
                    textClass="text-white text-xs"
                    paddingClass="px-3 py-2"
                    onClick={() => onPressDelete(rowData)}
                  />
                )}
              </div>,
              cell,
            ),
        },
      ],
    });
  };

  const onPressCreate = () => warehouseFormRef.current.showForm();
  const onPressEdit = (data) => warehouseFormRef.current.showFormWithInitialData(data);
  const onPressDelete = (data) => dispatch(deleteWarehouse(data.id));

  return (
    <>
      <div className="relative flex flex-col min-w-0 w-full h-full bg-white mb-8 shadow-lg rounded-xl">
        {/* Header */}
        <div className="flex flex-wrap items-center py-3 border-b">
          <div className="px-4 flex-1">
            <h3 className="font-semibold text-gray-800 pl-2">Store</h3>
          </div>
          <div className="px-4">
            <SubmitButton
              textClass="text-white text-xs"
              text="Tambah Store"
              onClick={onPressCreate}
            />
            <WarehouseCreate ref={warehouseFormRef} />
          </div>
        </div>

        {/* Table Content */}
        <div className="block w-full overflow-x-auto p-6">
          {/* Projects table */}
          <table
            id="warehouseDataTable"
            className="items-center w-full bg-transparent border-collapse">
            <thead>
              <tr>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left">
                  Nama
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left">
                  PIC
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left">
                  Alamat
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left">
                  iPay88
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left w-14">
                  Default
                </th>
                <th className="px-6 bg-gray-100 text-gray-600 align-middle border border-solid border-gray-200 text-xs uppercase border-l-0 border-r-0 font-semibold text-left w-40"></th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </>
  );
}
